import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteStocksize } from '../../Store/PHPSlice/stockApi';

const TableBody4 = ({
    serialNumber,
    id,
    // stkBarcode,
    itemId,
    itemNm,
    size,
    color,
    gqty,
    bqty,
    srate,
    prate,
    sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/SalePurchaseEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Item?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            const data = {
                stkId: id,
                itemId: itemId,
                size: size
            };
            // dispatch(deleteStocksize(data))
            //     .then(() => {
            //         // Reload the page to show updated results
            //         toast("Stock Deleted Sucessfully");
            //         window.location.reload();
            //     })
            //     .catch((error) => {
            //         // Handle any errors that occur during the deletion process
            //         console.error("Error deleting Item:", error);
            //         toast.error("Failed to delete Item");
            //     });
        }
    };

    const saleqty = parseFloat(gqty) - parseFloat(bqty);

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

              

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {color}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {gqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {saleqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {prate}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {srate}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${saleqty > 0 ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default TableBody4;
